var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components__cnt-richt_text",class:_vm.themingCssClasses(['sub_headline', 'sub_link'])},[(_vm.contentItem)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contentItem.widget_data.content)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }